import './public';

import React from 'react';
import ReactDOM from 'react-dom';

import { getTheme, getPartnerDisplayName, isTextchest } from './partners';
import { ThemeProvider } from '@mui/material/styles';
import App from './components/App';

// Partner-specific document metadata
document.title = getPartnerDisplayName();

if (isTextchest()) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = '/textchest-favicon.png';
}

const theme = getTheme();

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
